export interface AuthRedirectInput {
  isAuthenticated: boolean
  isInstallFlow: boolean
  searchRedirect?: string
}

const FALLBACK = '/organization'

export function getAuthRedirectTarget(input: AuthRedirectInput): string | null {
  if (!input.isAuthenticated) return null

  if (input.isInstallFlow) return '/installFlow/select-organization'

  return input.searchRedirect || FALLBACK
}
